import { NewPaperWithPadding } from '@components/Misc';
import { DataGrid, generateBasicColumn, generateEntityColumn, GridContainerFullHeight, Typography } from '@ts/storybook';
import { CReadingType, ISensor } from '@ts/ui-models';
import { useMemo } from 'react';

interface ISensorDataGridProps {
  sensors: ISensor[];
}

const SensorDataGrid = (props: ISensorDataGridProps) => {
  const columns = useMemo(
    () => [
      generateBasicColumn({ field: 'name' }, { field: 'name' }),
      generateEntityColumn({ field: 'readingType' }, { field: 'readingType', mainClass: CReadingType }),
      generateBasicColumn(
        {
          field: 'unit',
        },
        { field: 'readingType.unit.name' }
      ),
      generateBasicColumn(
        {
          field: 'physicalQuantity',
        },
        { field: 'readingType.unit.quantity.name' }
      ),
    ],
    []
  );

  return (
    <NewPaperWithPadding className={'p-0 w-full'}>
      <DataGrid
        key="dataGrid-sensors-device"
        componentSettings={{
          sortableColumns: [
            {
              field: 'name',
            },
          ],
        }}
        configComponent={{
          aclId: 'dataGridSensors',
          componentId: 'dataGridSensors',
        }}
        dataGridConfig={{
          sortModel: [{ field: 'name', sort: 'asc' }],
          widthColumns: { name: 250, readingType: 250, unit: 250, physicalQuantity: 250, streamParameters: 250 },
        }}
        propsDataGrid={{
          dataGridMode: 'client',
          withoutFooter: true,
          enabledFilters: true,
        }}
        propsDataGridToolbar={{
          title: <Typography variant="h5" className="pt-2 p-4 pb-0" text={[<b>Sensors</b>]} />,
          withoutSave: true,
          withoutTotal: true,
          withoutFilters: true,
        }}
        propsDataGridQuickAccess={{
          withoutActions: true,
        }}
        columns={columns}
        rows={{ count: props.sensors?.length ?? 0, rows: props.sensors ?? [] }}
      />
    </NewPaperWithPadding>
  );
};

export default SensorDataGrid;
